module.exports = __webpack_public_path__ + "static/media/foodprint_app9.7f5b7818.jpg";